"use client";

import { useEffect } from "react";

export default function RegisterSW() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    if (process.env.NODE_ENV === "development") {
      // Dev chunks retain their URLs across edits; cached copies break hydration.
      void navigator.serviceWorker
        .getRegistrations()
        .then(async (registrations) => {
          await Promise.all(
            registrations.map((registration) => {
              const worker =
                registration.active ||
                registration.waiting ||
                registration.installing;
              return worker && new URL(worker.scriptURL).pathname === "/sw.js"
                ? registration.unregister()
                : Promise.resolve(false);
            }),
          );
          if ("caches" in window) {
            await Promise.all(
              (await caches.keys())
                .filter((name) => name.startsWith("farbin-cache-"))
                .map((name) => caches.delete(name)),
            );
          }
        })
        .catch(() => undefined);
      return;
    }
    const register = () => {
      void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
    };
    if (document.readyState === "complete") register();
    else window.addEventListener("load", register, { once: true });
    return () => window.removeEventListener("load", register);
  }, []);

  return null;
}
